import Filter from './Filter';
import Refresh from '@monofront/design-system/visuals/Icons/Old/Refresh';
import ClearRefinements from './ClearRefinements';
import { useMediaQuery } from '@monofront/business/hooks';
import { useTranslations } from 'next-intl';
import useI18n from '@hooks/i18n/useI18n';
import GradeFilter from './GradeFilter';

type FilterRefinementListProps = {
  collectionLevel?: number;
};

const FilterRefinementList: React.FC<FilterRefinementListProps> = ({
  collectionLevel = 0,
}) => {
  const isMobile = useMediaQuery(800);
  const { isFrenchMarket } = useI18n();

  const tCatalog = useTranslations('Catalog');

  return (
    <>
      <div className="container">
        <div className="reset">
          <Refresh />
          <ClearRefinements />
        </div>
        <>
          {collectionLevel <= 2 ? (
            <Filter
              title={tCatalog('shelf')}
              withMultipleScrolls={!isMobile}
              isToggled
              attribute="shelfs"
              limit={4}
              showMoreLimit={1000}
              showMore
            />
          ) : null}
          <Filter
            title={tCatalog('diet')}
            isToggled={!(collectionLevel <= 2)}
            withMultipleScrolls={!isMobile}
            attribute="diets"
            limit={4}
            showMoreLimit={1000}
            showMore={true}
          />
          <Filter
            title={tCatalog('values')}
            withMultipleScrolls={!isMobile}
            attribute="values"
            limit={4}
            showMoreLimit={1000}
            showMore={true}
          />
          <Filter
            title={tCatalog('brand')}
            withMultipleScrolls={!isMobile}
            attribute="vendor"
            limit={4}
            showMoreLimit={1000}
            showMore={true}
          />
          <GradeFilter
            title={tCatalog('nutriscore')}
            attribute="meta.marketing.nutriscore_grade"
          />
          {isFrenchMarket && (
            <GradeFilter
              title={tCatalog('greenscore')}
              attribute="meta.marketing.environmentalscore_grade"
            />
          )}
        </>
      </div>
      <style jsx>{`
        .container {
          max-height: calc(100vh - 190px);
          overflow: hidden auto;
          border-radius: 4px;
        }

        .custom-hierarchical-menu {
          padding: var(--space-2) var(--space-4);
          max-height: 300px;
          border-bottom: var(--border);
          background-color: var(--clr-primary-6);
          overflow-y: scroll;
        }

        .custom-hierarchical-menu:empty {
          display: none;
        }

        .reset {
          display: none;
        }

        .sliders {
          padding: var(--space-5) var(--space-6);
        }

        .sliders:empty {
          display: none;
        }

        .sliders > :global(div:first-child) {
          margin-bottom: var(--space-4);
        }

        @media (max-width: 800px) {
          .container {
            max-height: unset;
            min-height: calc(100vh - 80px);
            border: none;
          }

          .sliders {
            background: var(--clr-primary-5);
          }

          .reset {
            justify-content: flex-end;
            align-items: center;
            display: flex;
            padding: var(--space-5) var(--space-3);
            border-bottom: var(--border);
          }

          .custom-hierarchical-menu {
            background-color: var(--clr-primary-5);
          }
        }
      `}</style>
    </>
  );
};

export default FilterRefinementList;
